export function location(state = [], action) {
  switch (action.type) {
    case "LOCATION_RECEIVED":
      return action.data;
    default:
      return state;
  }
}
